<script>
export default {
    name: 'ContentTextBlock',
    props: {
        data: Object,
    },
};
</script>

<template>
    <div class="text-block richtext">
        <h2 class="text-block__title" v-if="data.title">{{ data.title }}</h2>
        <div class="text-block__content" v-html="data.text"></div>
    </div>
</template>

<style lang="scss">

</style>
